// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  ExpandableOverviewItem,
  SpanWithData
} from '../'

import {
  CreditInputs
} from './CreditInputs'

import {
  CreditEligibility
} from './CreditEligibility'

import {
  showAsCurrency,
  isEmptyObject,
  hasResponsibility
} from '../../utils'


export class CreditCalculationsConsolidation extends React.Component {
  static propTypes = {
    assignedToIdentityId: PropTypes.string,
    updatedBy: PropTypes.shape({
      id: PropTypes.string.isRequired,
      identity: PropTypes.shape({
        id: PropTypes.string.isRequired,
        fullName: PropTypes.string.isRequired
      })
    }).isRequired,
    overrideBy: PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired
    }).isRequired,
    overrideAt: PropTypes.string,
    creditType: PropTypes.string.isRequired,
    amountEligibleFor: PropTypes.number,
    open: PropTypes.bool.isRequired,
    updateCreditApplication: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  state = {
    cashAppliedForEligible: null,
    retailAppliedForEligible: null,
    consolidationAppliedForEligible: null,
    showDetails: false
  }

  showLoanEligibleFor = (creditType, amountEligibleFor) => (
    <React.Fragment>
      <SpanWithData forField='CreditCreditType' searchKey={creditType} />
      {`: ${showAsCurrency('R', amountEligibleFor)}`}
    </React.Fragment>
  )

  isEligibleForLoansAppliedFor = (amountAppliedFor, amountEligibleFor) => (
    (amountAppliedFor && amountAppliedFor > 0 && amountEligibleFor)
  )

  toggleShowDetails = () => this.setState(prevState => ({ showDetails: !prevState.showDetails }))

  hasNoLimitationResults = (limitations) => (
    isEmptyObject(limitations) || Object.values(limitations).find(value => value === null)
    // 2nd condition checks whether limitation object properties are null, which would cause KeyValueTable with 'highlight' prop breakage as it will attempt to match payroll cycle against null value
  )

  render() {
    let { assignedToIdentityId, client, updatedBy, overrideBy, overrideAt, creditType, amountAppliedFor, amountEligibleFor, open, updateCreditApplication, onClick, className } = this.props
    let appliedForLoansEligible = this.isEligibleForLoansAppliedFor(amountAppliedFor, amountEligibleFor)

    let userHasOverridePermission = hasResponsibility('self', 'loanapplication_override')

    return (
      <ExpandableOverviewItem
        title='Calculations'
        summary={this.showLoanEligibleFor(creditType, amountEligibleFor)}
        iconSymbol={appliedForLoansEligible
          ? 'check'
          : null
        }
        iconColour={appliedForLoansEligible
          ? 'success'
          : null
        }
        open={open}
        onClick={onClick}
        className={className}>
        {userHasOverridePermission &&
          <CreditInputs
            membershipStatus={client.identity.membershipStatus}
            earnbacksStatus={client.identity.earnbacksStatus}
            picsaMembershipLength={client.identity.picsaMembershipLength}
            earnbacksMembershipLength={client.identity.earnbacksMembershipLength}
            clientEmploymentType={client.employmentType}
            clientSalaryMonthly={client.salaryMonthly}
            clientSalaryCycle={client.salary}
            healthLevelHistory={client.identity.healthLevelHistory}
            employerCreditMultiplier={client.division.employer.creditMultiplier}
            balanceShorttermInvestedIncl={client.identity.balanceShorttermInvestedIncl}
            balanceLongtermInvestedIncl={client.identity.balanceLongtermInvestedIncl}
            earnbacksBalance={client.identity.earnbacksBalance}
            investmentShortClientMonthlyContribution={client.identity.investmentShortClientMonthlyContribution}
            investmentLongClientMonthlyContribution={client.identity.investmentLongClientMonthlyContribution}
          />
        }
        <CreditEligibility
          assignedToIdentityId={assignedToIdentityId}
          overrideBy={overrideBy}
          overrideAt={overrideAt}
          updatedBy={updatedBy}
          creditType={creditType}
          amountEligibleFor={amountEligibleFor}
          updateCreditApplication={updateCreditApplication}
          refetchData={this.props.refetchData}
          userHasOverridePermission={userHasOverridePermission}
        />
      </ExpandableOverviewItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/creditapplication-modal/CreditCalculationsConsolidation.js